import React from 'react';

import FeedDifferencesMinitable from './feed-differences-minitable';

import './feed-differences.scss';

const FeedDifferences = ({ merchantId, fieldName, match }) => {
	const feedDifferenceCounts = merchantId ? (
		<FeedDifferencesMinitable
			merchantId={merchantId}
			match={match}
			statType="feed_difference_counts"
		/>
	) : null;
	const feedDifferencesByField = fieldName ? (
		<FeedDifferencesMinitable
			merchantId={merchantId}
			fieldName={fieldName}
			statType="feed_differences_by_field"
		/>
	) : null;

	return (
		<div className="feed-differences">
			<div className="table-container">
				{feedDifferenceCounts}
				{feedDifferencesByField}
			</div>
		</div>
	);
};

export default FeedDifferences;
